module.exports = __webpack_public_path__ + "static/media/ep-logo.2b322518.svg";